var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    [
      _c(
        "a-card",
        {
          staticStyle: { width: "250px", float: "left" },
          attrs: { bordered: false },
        },
        [
          _c("div", [
            _c(
              "h3",
              [
                _vm._v("\n        档案合成器\n        "),
                _c(
                  "a-tooltip",
                  {
                    scopedSlots: _vm._u([
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("div", [_vm._v("一键完成档案合成")]),
                            _c("div", [_vm._v("1、3分钟时完成心理筛查")]),
                            _c("div", [
                              _vm._v("2、支持导入各种心理量表，一键合成新档案"),
                            ]),
                            _c("div", [
                              _vm._v(
                                "3、情绪指数多维度分析，学生心理筛查更精准"
                              ),
                            ]),
                            _c("div", [_vm._v("4、支持多种形式筛选排序")]),
                            _c("div", [_vm._v("5、档案记录永久保存")]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("a-icon", {
                      staticStyle: { cursor: "pointer", color: "dodgerblue" },
                      attrs: { type: "info-circle" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("h5", [
              _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
              _vm._v("\n        仅支持xlsx和xls格式的文件\n      "),
            ]),
          ]),
          _c(
            "a-button",
            {
              staticStyle: {
                background: "rgb(250, 150, 0)",
                color: "white",
                "font-weight": "bold",
                width: "100%",
                height: "35px",
                "solid-color": "#faad14",
              },
              on: { click: _vm.showModal },
            },
            [_vm._v("\n      导入文件\n    ")]
          ),
          _c(
            "a-row",
            {
              staticStyle: { "margin-top": "20px" },
              attrs: { gutter: [24, 12] },
            },
            [
              _vm._l(_vm.archiveList, function (item) {
                return [
                  _c(
                    "a-col",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        "white-space": "nowrap",
                        "text-overflow": "ellipsis",
                        cursor: "pointer",
                      },
                      attrs: { span: "16" },
                      on: {
                        click: function ($event) {
                          return _vm.showArchiveData(item)
                        },
                      },
                    },
                    [
                      _c("a-icon", {
                        staticStyle: { color: "#52c41a" },
                        attrs: { type: "file-excel" },
                      }),
                      _vm._v(
                        "\n          " + _vm._s(item.title) + "\n        "
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: "8" } },
                    [
                      _c(
                        "a-popconfirm",
                        {
                          attrs: { title: "确定删除吗?" },
                          on: {
                            confirm: () => _vm.handleDeleteArchive(item.id),
                          },
                        },
                        [_c("a", [_vm._v("删除")])]
                      ),
                    ],
                    1
                  ),
                ]
              }),
            ],
            2
          ),
          _c(
            "a-modal",
            {
              attrs: { title: "档案合成器", width: _vm.widthDialog },
              scopedSlots: _vm._u([
                {
                  key: "footer",
                  fn: function () {
                    return [
                      _c("a-button", { on: { click: _vm.handleCancel } }, [
                        _vm._v("取消"),
                      ]),
                      _c(
                        "a-button",
                        {
                          attrs: {
                            disabled: _vm.fileList.length === 0,
                            loading: _vm.uploading,
                            type: "primary",
                          },
                          on: { click: _vm.handleOk },
                        },
                        [_vm._v("\n          一键合成\n        ")]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
              model: {
                value: _vm.isModalVisible,
                callback: function ($$v) {
                  _vm.isModalVisible = $$v
                },
                expression: "isModalVisible",
              },
            },
            [
              _c(
                "div",
                [
                  _c(
                    "a-form-model",
                    {
                      ref: "form",
                      attrs: { model: _vm.model, rules: _vm.validatorRules },
                    },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "第一步：下载模版" } },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  _vm.window._CONFIG["resourceURL"] +
                                  "/school/sys/common/static/ArchiveSynthesizer/学生心理档案合成器模版.xlsx",
                              },
                            },
                            [
                              _vm._v(
                                "\n              下载导入心理档案Excel模版\n            "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "第二步：输入生成文档标题",
                            prop: "title",
                          },
                        },
                        [
                          _c("a-input", {
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请输入文档标题" },
                            model: {
                              value: _vm.model.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.model, "title", $$v)
                              },
                              expression: "model.title",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "第三步：添加文件" } },
                        [
                          _c(
                            "a-upload-dragger",
                            {
                              attrs: {
                                accept: ".xls,.xlsx",
                                name: "file",
                                "file-list": _vm.fileList,
                                multiple: true,
                                action: _vm.uploadAction,
                                headers: _vm.tokenHeader,
                              },
                              on: { change: _vm.handleChange },
                            },
                            [
                              _c(
                                "p",
                                { staticClass: "ant-upload-drag-icon" },
                                [_c("a-icon", { attrs: { type: "inbox" } })],
                                1
                              ),
                              _c("p", { staticClass: "ant-upload-text" }, [
                                _vm._v("添加文件"),
                              ]),
                              _c("p", { staticClass: "ant-upload-hint" }, [
                                _vm._v("(仅支持.xls或.xlsx格式的文件)"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "a-card",
        {
          staticStyle: {
            "margin-left": "20px",
            width: "calc(100% - 274px)",
            float: "left",
          },
          attrs: { bordered: false },
        },
        [
          _c(
            "div",
            { staticClass: "table-page-search-wrapper" },
            [
              _c(
                "a-form",
                { attrs: { layout: "inline" } },
                [
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "年级名称" } },
                            [
                              _c("j-dict-select-tag", {
                                staticStyle: { width: "250px" },
                                attrs: {
                                  disabled: _vm.isShowArchiveData,
                                  placeholder: "请选择年级",
                                  dictCode:
                                    "school_grade,grade_name,id,0=delete_flag order by sort_order",
                                  allowClear: "",
                                },
                                model: {
                                  value: _vm.queryParam.gradeId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryParam, "gradeId", $$v)
                                  },
                                  expression: "queryParam.gradeId",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "班级名称" } },
                            [
                              _c("j-dict-select-tag", {
                                staticStyle: { width: "250px" },
                                attrs: {
                                  disabled: _vm.isShowArchiveData,
                                  placeholder: "请选择班级",
                                  dictCode:
                                    "school_class,name,id,grade_id=" +
                                    (!_vm.queryParam.gradeId
                                      ? -1
                                      : _vm.queryParam.gradeId),
                                  async: true,
                                },
                                model: {
                                  value: _vm.queryParam.classId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryParam, "classId", $$v)
                                  },
                                  expression: "queryParam.classId",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "学生姓名" } },
                            [
                              _c("a-input", {
                                attrs: {
                                  disabled: _vm.isShowArchiveData,
                                  placeholder: "请输入学生姓名",
                                },
                                model: {
                                  value: _vm.queryParam.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryParam, "name", $$v)
                                  },
                                  expression: "queryParam.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "是否关爱名单" } },
                            [
                              _c("j-dict-select-tag", {
                                attrs: {
                                  disabled: _vm.isShowArchiveData,
                                  placeholder: "请选择是否关爱名单",
                                  dictCode: "yn",
                                },
                                model: {
                                  value: _vm.queryParam.careList,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryParam, "careList", $$v)
                                  },
                                  expression: "queryParam.careList",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "时间范围" } },
                            [
                              _c(
                                "a-select",
                                {
                                  staticStyle: { width: "250px" },
                                  attrs: {
                                    disabled: _vm.isShowArchiveData,
                                    placeholder: "请选择时间范围",
                                  },
                                  on: { change: _vm.onTimeRangeChange },
                                  model: {
                                    value: _vm.queryParam.timeRange,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.queryParam, "timeRange", $$v)
                                    },
                                    expression: "queryParam.timeRange",
                                  },
                                },
                                [
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "xz" } },
                                    [_vm._v("请选择")]
                                  ),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "last7days" } },
                                    [_vm._v("近七日")]
                                  ),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "last20days" } },
                                    [_vm._v("近二十天")]
                                  ),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "last40days" } },
                                    [_vm._v("近四十天")]
                                  ),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "last3months" } },
                                    [_vm._v("近三个月")]
                                  ),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "last6months" } },
                                    [_vm._v("近半年")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "时间范围" } },
                            [
                              _c("a-range-picker", {
                                staticStyle: { width: "250px" },
                                attrs: {
                                  disabled: _vm.isShowArchiveData,
                                  value: _vm.rangeDate,
                                },
                                on: { change: _vm.onRangeChange },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("a-col", { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } }, [
                        _c(
                          "span",
                          {
                            staticClass: "table-page-search-submitButtons",
                            staticStyle: { float: "left", overflow: "hidden" },
                          },
                          [
                            _c(
                              "a-button",
                              {
                                attrs: {
                                  type: "primary",
                                  disabled: _vm.isShowArchiveData,
                                  icon: "search",
                                },
                                on: { click: _vm.searchQuery },
                              },
                              [_vm._v("\n                查询\n              ")]
                            ),
                            _c(
                              "a-button",
                              {
                                staticStyle: { "margin-left": "8px" },
                                attrs: { type: "primary", icon: "reload" },
                                on: { click: _vm.reset },
                              },
                              [_vm._v("\n                重置\n              ")]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "table-operator" },
            [
              _c(
                "a-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isShowArchiveData,
                      expression: "isShowArchiveData",
                    },
                  ],
                  attrs: { type: "primary", icon: "download" },
                  on: { click: _vm.exportXls },
                },
                [_vm._v("\n        导出\n      ")]
              ),
            ],
            1
          ),
          _c(
            "div",
            [
              _c("a-table", {
                ref: "table",
                staticClass: "j-table-force-nowrap",
                attrs: {
                  size: "middle",
                  bordered: "",
                  rowKey: "id",
                  columns: _vm.columns,
                  scroll: { x: true },
                  dataSource: _vm.dataSource,
                  pagination: _vm.ipagination,
                  loading: _vm.loading,
                  rowSelection: {
                    selectedRowKeys: _vm.selectedRowKeys,
                    onChange: _vm.onSelectChange,
                  },
                },
                on: { change: _vm.handleTableChange },
                scopedSlots: _vm._u([
                  {
                    key: "action",
                    fn: function (text, record) {
                      return _c("span", {}, [
                        _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.changeSelect(record)
                              },
                            },
                          },
                          [_vm._v("更多")]
                        ),
                      ])
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ]
      ),
      _c("ViewKeyPointModal", { ref: "viewKeyPointModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }